import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState } from 'react';
import '@dynamic-labs/sdk-api';
import { logger } from '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import '../../utils/constants/colors.js';
import { useOnClickOutside } from '../../shared/utils/hooks/useOnClickOutside/index.js';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';
import { NetworkControl } from './components/NetworkControl/NetworkControl.js';
import { ActionList } from './components/ActionList/ActionList.js';
import { NetworkAction } from './components/NetworkAction/NetworkAction.js';

const NetworkPicker = ({ activeClassName = '', buttonClassName = '', checkboxClassName = '', connector, evmNetworks, isNetworkPickerOpen, listClassName = '', mainClassName = '', setIsNetworkPickerOpen, showNetworkName, }) => {
    const pickerRef = useRef(null);
    const [newNetworkId, setNewNetworkId] = useState(undefined);
    const { loadingNetwork, network, setNetwork } = useInternalDynamicContext();
    useOnClickOutside(pickerRef, () => {
        if (isNetworkPickerOpen) {
            setIsNetworkPickerOpen(false);
        }
    });
    const handleNetworkChange = (networkId) => __awaiter(void 0, void 0, void 0, function* () {
        setNewNetworkId(networkId);
        try {
            yield (connector === null || connector === void 0 ? void 0 : connector.switchNetwork({
                networkChainId: networkId,
            }));
            const chainId = yield (connector === null || connector === void 0 ? void 0 : connector.getNetwork());
            setNetwork(chainId);
        }
        catch (error) {
            /* istanbul ignore next */
            logger.debug(error);
        }
        finally {
            setNewNetworkId(undefined);
            setIsNetworkPickerOpen(false);
        }
    });
    return (jsxs("div", Object.assign({ className: classNames('non-widget-network-picker', mainClassName), ref: pickerRef }, { children: [jsx(NetworkControl, { evmNetworks: evmNetworks, activeClassName: activeClassName, network: network, loading: loadingNetwork, isOpen: isNetworkPickerOpen, setIsOpen: setIsNetworkPickerOpen, walletConnector: connector, showNetworkName: showNetworkName, buttonClassName: buttonClassName }), evmNetworks && Boolean(evmNetworks.length) && (jsx(ActionList, Object.assign({ className: listClassName, title: 'Select network', isOpen: isNetworkPickerOpen, setIsOpen: setIsNetworkPickerOpen }, { children: jsx("div", Object.assign({ className: 'network-picker__dropdown' }, { children: evmNetworks.map(({ chainName, networkId, vanityName, iconUrls }) => (jsx(NetworkAction, { iconUrl: iconUrls === null || iconUrls === void 0 ? void 0 : iconUrls[0], networkId: networkId, networkName: vanityName || chainName, network: network, onClick: handleNetworkChange, checkboxClassName: checkboxClassName, newNetworkId: newNetworkId }, networkId))) })) })))] })));
};

export { NetworkPicker };
